import { Routes } from '@angular/router';

import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { LoginComponent } from '@core/login/login.component';
import { AuthGuard } from '@shared/services/guards/auth-guard.service';

import { BlockNewLoginComponent } from './core/block-login/block-new-login.component'
export const AppRoutes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: '',
    component: AdminLayoutComponent,
    children: [{
      path: '',
      loadChildren: () => import('./layouts/admin-layout/admin-layout.module').then(m => m.AdminLayoutModule)
      }],
    canActivate: [AuthGuard]
  },
  {
    path: 'block-new-login',
    component: BlockNewLoginComponent
  },
  {
    path: '**',
    redirectTo: ''
  }

]
